import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from '@ipc/ipc-core';

import { MenuWrapper, MenuItem } from './styles';

export default function HeaderMenu() {
  return (
    <MenuWrapper>
      <MenuItem>
        <div className="MenuParent">
          <FontAwesomeIcon icon="chevron-down" className="icon" />
          <span>Query</span>
        </div>

        <div className="MenuChildren">
          <div className="MenuChild">
            <Link to="/pre-settlement/create" className="MenuChildLink">
              Create Settlement Request
            </Link>
          </div>
          <div className="MenuChild">
            <Link to="/pre-settlement/list" className="MenuChildLink">
              View Settlement Requests
            </Link>
          </div>
        </div>
      </MenuItem>
      <MenuItem>
        <div className="MenuParent">
          <FontAwesomeIcon icon="chevron-down" className="icon" />
          <span>List View</span>
        </div>

        <div className="MenuChildren">
          <div className="MenuChild">
            <Link to="/receptacles/list/search" className="MenuChildLink">
              All Receptacles
            </Link>
          </div>
          <div className="MenuChild">
            <Link to="/receptacles/list/pending/search" className="MenuChildLink">
              Receptacles Pending Approval
            </Link>
          </div>
          <div className="MenuChild">
            <Link to="/receptacles/list/approved/search" className="MenuChildLink">
              Receptacles Approved
            </Link>
          </div>
          <div className="MenuChild">
            <Link to="/receptacles/list/disapproved/search" className="MenuChildLink">
              Receptacles Disapproved
            </Link>
          </div>
          <div className="MenuChild">
            <Link to="/receptacles/list/failed/search" className="MenuChildLink">
              Receptacles with Discrepancies
            </Link>
          </div>
        </div>
      </MenuItem>
      <MenuItem>
        <div className="MenuParent">
          <Link to="/performance" className="">
            Performance
          </Link>
        </div>
      </MenuItem>
      <MenuItem>
        <div className="MenuParent">
          <FontAwesomeIcon icon="chevron-down" className="icon" />
          <span>Receptacle Invoice Management</span>
        </div>
        <div className="MenuChildren">
          <div className="MenuChild">
            <Link to="/invoice/search" className="MenuChildLink">
              Invoice information
            </Link>
          </div>
        </div>
      </MenuItem>
      <MenuItem>
        <div className="MenuParent">
          <Link to="/master-data" className="">
            Upload Receptacle Data
          </Link>
        </div>
      </MenuItem>
      <MenuItem>
        <div className="MenuParent">
          <FontAwesomeIcon icon="chevron-down" className="icon" />
          <span>Configuration</span>
        </div>

        <div className="MenuChildren">
          <div className="MenuChild">
            <Link to="/configuration/default" className="MenuChildLink">
            ALA Display Default Level
            </Link>
          </div>
          <div className="MenuChild">
            <Link to="/configuration/agreements" className="MenuChildLink">
              ALA Level Agreements
            </Link>
          </div>
        </div>
      </MenuItem>
    </MenuWrapper>
  );
}
